import { Dayjs } from "dayjs";
import { useCallback, useState } from "react";
import { editBatch } from "../../../../../../../acions/processing/batches";
import { useAppDispatch } from "../../../../../../../store";
import { IBatchGet } from "../../../../../../../types/Batches";
import dayjs from "../../../../../../../configs/dayjs";

export const useUpdatePaymentDate = (
  onCloseEdit: () => void,
  datePickerStatus: undefined | "error",
  updateDataPaymentDate: () => void,
  data: IBatchGet
) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const update = useCallback(
    (value: Dayjs | null, id: string) => {
      if (!datePickerStatus) {
        setIsLoading(true);

        const request = {
          date: data.date,
          paymentsDate: value ? value.format() : dayjs().format(),
          isCreatorPaymentOnly: data.isCreatorPaymentOnly,
          type: data.type,
        };

        Promise.resolve(dispatch(editBatch(request, id)))
          .then(() => {
            setIsLoading(false);

            updateDataPaymentDate && updateDataPaymentDate();
          })
          .catch(() => {
            setIsLoading(false);
            onCloseEdit();
          });
      }
    },
    [data, dispatch, onCloseEdit, updateDataPaymentDate, datePickerStatus]
  );

  return { isLoading, update };
};
